import { Grid } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import api from "services/api";
import BlogCard from "./blogcard";

const UserBlogs = ({ userid = "self" }) => {
  const [draftBlogsData, setDraftBlogsData] = useState([]);
  const [publishedBlogsData, setPublishedBlogsData] = useState([]);

  const reload = () => {
    try {
      api.blog.getuserblogs(userid).then(({ data }) => {
        setDraftBlogsData(data.blogs.filter((b) => b.status == "draft"));
        setPublishedBlogsData(data.blogs.filter((b) => b.status == "published"));
        console.log("data.blogs", data.blogs);
        return data;
      });
    } catch (err) {
      toast.error(`getuserblogs failed!`);
      console.log(err);
    }
  };

  useEffect(() => {
    if (userid) {
      reload();
    }
  }, [userid]);

  return (
    <SuiBox p={2}>
      {userid == "self" && (
        <SuiBox mb={10}>
          <SuiBox className="m-2 justify-between" display="flex" alignItems="center">
            <SuiTypography variant="h2" fontWeight="medium">
              {"Draft Blogs(" + draftBlogsData.length + ")"}
            </SuiTypography>
            <SuiButton
              variant="outlined"
              color={"dark"}
              component={Link}
              to={`/social/blog?create=1`}
            >
              Create Blog
            </SuiButton>
          </SuiBox>
          <Grid container spacing={3} justify="space-between" alignItems="stretch">
            {draftBlogsData.map((blog) => {
              return (
                <Grid item style={{ width: "33%" }}>
                  <BlogCard blog={blog} refreshParent={reload} />
                </Grid>
              );
            })}
          </Grid>
        </SuiBox>
      )}
      <SuiBox>
        <SuiBox className="m-2 justify-between" display="flex" alignItems="center">
          <SuiTypography variant="h2" fontWeight="medium">
            {"Published Blogs(" + publishedBlogsData.length + ")"}
          </SuiTypography>
        </SuiBox>
        <Grid container spacing={3} alignItems="stretch">
          {publishedBlogsData.map((blog) => {
            return (
              <Grid item key={blog.id} xs={4}>
                <BlogCard blog={blog} refreshParent={reload} />
              </Grid>
            );
          })}
        </Grid>
      </SuiBox>
    </SuiBox>
  );
};

export default UserBlogs;
